export const BASE_URL = 'https://apihrms-staging.atwpl.com'
// export const BASE_URL = 'http://localhost:8081'
export const HIRING_PORTAL_URL = 'https://www.hirectx.com'
export const HIRING_PORTAL_API_URL = 'https://www.hirectx.com'